import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"],
    _excluded2 = ["className", "meta", "children", "isFieldChildren", "showValidateMessage", "colon", "layout", "labelAlign", "inputAlign", "border"],
    _excluded3 = ["className", "style", "label", "name", "required", "noStyle", "tooltip", "intro", "customField", "disabled", "colon", "rules", "children", "messageVariables", "trigger", "validateTrigger", "onClick", "shouldUpdate", "dependencies", "labelWidth", "labelAlign", "labelClass", "showValidateMessage", "inputAlign", "errorMessageAlign", "border", "layout"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-console */
import React from 'react';
import clsx from 'clsx';
import { Field as RcField } from 'rc-field-form';
import FieldContext from 'rc-field-form/lib/FieldContext';
import Field from '../field';
import { toArray } from '../uploader/utils';
import { FIELD_KEY } from '../field/Field';
import { COMPONENT_TYPE_KEY } from '../utils/constant';
import { FormContext } from './FormContext';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';
import { devWarning } from '../utils/dev-log';
var MemoInput = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.cloneElement(children, props);
}, function (prev, next) {
  return prev.value === next.value && prev.update === next.update;
});

var FormItemLayout = function FormItemLayout(props) {
  var className = props.className,
      meta = props.meta,
      children = props.children,
      isFieldChildren = props.isFieldChildren,
      showValidateMessage = props.showValidateMessage,
      colon = props.colon,
      layout = props.layout,
      labelAlign = props.labelAlign,
      inputAlign = props.inputAlign,
      border = props.border,
      fieldProps = _objectWithoutProperties(props, _excluded2);

  var _React$useContext = React.useContext(ConfigProviderContext),
      prefixCls = _React$useContext.prefixCls,
      createNamespace = _React$useContext.createNamespace;

  var _createNamespace = createNamespace('form', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var context = React.useContext(FormContext);
  var itemLayout = layout !== null && layout !== void 0 ? layout : context.layout;
  var itemBorder = border !== null && border !== void 0 ? border : context.border;
  var itemColon = colon !== null && colon !== void 0 ? colon : context.colon;
  var itemShowValidateMessage = showValidateMessage !== null && showValidateMessage !== void 0 ? showValidateMessage : context.showValidateMessage;
  var itemLabelAlign = labelAlign !== null && labelAlign !== void 0 ? labelAlign : context.labelAlign;
  var itemInputAlign = inputAlign !== null && inputAlign !== void 0 ? inputAlign : context.inputAlign;
  var error = meta && meta.errors.length > 0;
  var errorMessage = itemShowValidateMessage && error ? meta.errors[0] : null;

  var attrs = _objectSpread(_objectSpread({}, fieldProps), {}, {
    className: clsx(bem({
      vertical: itemLayout === 'vertical'
    }), className),
    colon: itemColon,
    error: error,
    errorMessage: errorMessage,
    labelAlign: itemLabelAlign,
    inputAlign: itemInputAlign,
    border: itemBorder
  });

  if (isFieldChildren) return /*#__PURE__*/React.cloneElement(children, attrs);
  return /*#__PURE__*/React.createElement(Field, attrs, children);
};

var FormItem = function FormItem(props) {
  var _type;

  var className = props.className,
      style = props.style,
      label = props.label,
      name = props.name,
      required = props.required,
      noStyle = props.noStyle,
      tooltip = props.tooltip,
      intro = props.intro,
      customField = props.customField,
      disabled = props.disabled,
      colon = props.colon,
      rules = props.rules,
      children = props.children,
      messageVariables = props.messageVariables,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'onChange' : _props$trigger,
      validateTrigger = props.validateTrigger,
      onClick = props.onClick,
      shouldUpdate = props.shouldUpdate,
      dependencies = props.dependencies,
      labelWidth = props.labelWidth,
      labelAlign = props.labelAlign,
      labelClass = props.labelClass,
      showValidateMessage = props.showValidateMessage,
      inputAlign = props.inputAlign,
      errorMessageAlign = props.errorMessageAlign,
      border = props.border,
      layout = props.layout,
      fieldProps = _objectWithoutProperties(props, _excluded3);

  var _React$useContext2 = React.useContext(FieldContext),
      contextValidateTrigger = _React$useContext2.validateTrigger;

  var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
  var updateRef = React.useRef(0);
  updateRef.current += 1;
  var isFieldChildren = ((_type = children.type) === null || _type === void 0 ? void 0 : _type[COMPONENT_TYPE_KEY]) === FIELD_KEY || customField;

  function renderLayout(baseChildren, fieldId, meta, isRequired) {
    if (noStyle) {
      return baseChildren;
    }

    return /*#__PURE__*/React.createElement(FormItemLayout, {
      isFieldChildren: isFieldChildren,
      className: className,
      style: style,
      label: label,
      tooltip: tooltip,
      intro: intro,
      required: isRequired,
      disabled: disabled,
      htmlFor: fieldId,
      meta: meta,
      colon: colon,
      border: border,
      layout: layout,
      labelWidth: labelWidth,
      labelAlign: labelAlign,
      labelClass: labelClass,
      inputAlign: inputAlign,
      errorMessageAlign: errorMessageAlign,
      showValidateMessage: showValidateMessage,
      onClick: onClick
    }, baseChildren);
  }

  var isRenderProps = typeof children === 'function';

  if (!name && !isRenderProps && !props.dependencies) {
    return renderLayout(children);
  }

  var variables = {};

  if (typeof label === 'string') {
    variables.label = label;
  }

  if (messageVariables) {
    variables = _objectSpread(_objectSpread({}, variables), messageVariables);
  }

  return /*#__PURE__*/React.createElement(RcField, _extends({}, fieldProps, {
    name: name,
    shouldUpdate: shouldUpdate,
    dependencies: dependencies,
    rules: rules,
    trigger: trigger,
    validateTrigger: mergedValidateTrigger
  }), function (control, meta, context) {
    var childNode = null;
    var isRequired = required !== undefined ? required : !!(rules && rules.some(function (rule) {
      if (rule && _typeof(rule) === 'object' && rule.required) {
        return true;
      }

      return false;
    }));
    var fieldId = (toArray(name).length && meta ? meta.name : []).join('_');

    if (shouldUpdate && dependencies) {
      devWarning('Form.Item', "`shouldUpdate` and `dependencies` shouldn't be used together.");
    }

    if (isRenderProps) {
      if ((shouldUpdate || dependencies) && !name) {
        childNode = children(context);
      } else {
        if (!(shouldUpdate || dependencies)) {
          devWarning('Form.Item', '`children` of render props only work with `shouldUpdate` or `dependencies`.');
        }

        if (name) {
          devWarning('Form.Item', "Do not use `name` with `children` of render props since it's not a field.");
        }
      } // not render props

    } else if (dependencies && !name) {
      devWarning('Form.Item', 'Must set `name` or use render props when `dependencies` is set.');
    } else if ( /*#__PURE__*/React.isValidElement(children)) {
      var childProps = _objectSpread(_objectSpread({}, children.props), control);

      if (!childProps.id) {
        childProps.id = fieldId;
      }

      if (disabled) {
        childProps.disabled = disabled;
      } // We should keep user origin event handler


      var triggers = new Set([].concat(_toConsumableArray(toArray(trigger)), _toConsumableArray(toArray(mergedValidateTrigger))));
      triggers.forEach(function (eventName) {
        childProps[eventName] = function () {
          var _control$eventName, _children$props$event, _children$props;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          (_control$eventName = control[eventName]) === null || _control$eventName === void 0 ? void 0 : _control$eventName.call.apply(_control$eventName, [control].concat(args));
          (_children$props$event = (_children$props = children.props)[eventName]) === null || _children$props$event === void 0 ? void 0 : _children$props$event.call.apply(_children$props$event, [_children$props].concat(args));
        };
      });
      childNode = /*#__PURE__*/React.createElement(MemoInput, {
        value: control[props.valuePropName || 'value'],
        update: updateRef.current
      }, /*#__PURE__*/React.cloneElement(children, childProps));

      if (isFieldChildren) {
        childProps.value = childProps.value || '';
        childNode = /*#__PURE__*/React.cloneElement(children, childProps);
      }
    } else {
      if (name) {
        devWarning('Form.Item', '`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead.');
      }

      childNode = children;
    }

    return renderLayout(childNode, fieldId, meta, isRequired);
  });
};

export default FormItem;